/**
 * Created by mohameds on 8/7/19.
 */
import {axiosInstance, getAuthToken,axiosInstanceWithToken}  from "../utils/Client";
import {MonitorConst} from '../components/agencyMonitor/Constants'

export default class AgencyMonitorService {
  static getHeaderSettings = (locationId) => {
    return axiosInstance.get(`agency_monitor/setting/${locationId}/`,
      {
        headers: {
          Authorization: getAuthToken()
        }
      }
    );
  };
  static getFormData = (object) => {
    const formData = new FormData();
    Object.keys(object).forEach(key => {
      if (!(key === 'birth_date' && !object[key])) {
        formData.append(key, object[key]);
      }

    });
    return formData;
  };

  static postHeaderSettings = (locationId, settings) => {
    const setting = AgencyMonitorService.getFormData(settings);
    return axiosInstance.put(`agency_monitor/setting/${locationId}/`,
      setting,
      {
        headers: {
          Authorization: getAuthToken()
        }
      }
    );
  }

  static getUsers = (locationId) => {
    return axiosInstance.get(`/agency_monitor/users/${locationId}/`,
      {
        headers: {
          Authorization: getAuthToken()
        }
      }
    );
  };
  static getPageList = () => {
    return axiosInstance.get(`/agency_monitor/page_type/`,
      {
        headers: {
          Authorization: getAuthToken()
        }
      }
    );
  };
  static pagePositionList = (userId, action, pagePosition) => {
    switch (action) {
      case MonitorConst.Action.PUT : {
        return axiosInstance.put(`/agency_monitor/page/list/${userId}/`,
          pagePosition,
          {
            headers: {
              Authorization: getAuthToken()
            }
          }
        );
      }
      default : {
        return axiosInstance.get(`/agency_monitor/page/list/${userId}/`,
          {
            headers: {
              Authorization: getAuthToken()
            }
          }
        );
      }
    }

  };
  static getPageInformation = (pageId) => {
    return axiosInstance.get(`/agency_monitor/page/${pageId}/`,
      {
        headers: {
          Authorization: getAuthToken()
        }
      }
    );
  };

  static getMonitorPageList = () => {
    return axiosInstance.get(`/agency_monitor/page/all/`,
      {
        headers: {
          Authorization: getAuthToken()
        }
      }
    );
  };

  //save page settings
  static savePageSetting = (pageData) => {
    return axiosInstance.post(`/agency_monitor/page/`,
      pageData,
      {
        headers: {
          Authorization: getAuthToken()
        }
      }
    );
  };

  //alter page settings
  static alterPageSettings = (pageId, action, pageData) => {
    switch (action) {
      case MonitorConst.Action.DELETE : {
        return axiosInstance.delete(`/agency_monitor/page/${pageId}/`,
          {
            headers: {
              Authorization: getAuthToken()
            }
          }
        );
      }
      case MonitorConst.Action.PUT :{
        return axiosInstance.put(`/agency_monitor/page/${pageId}/`,
          pageData,
          {
            headers: {
              Authorization: getAuthToken()
            }
          }
        );
      }
      default: {
        return axiosInstance.get(`/agency_monitor/page/${pageId}/`,
          {
            headers: {
              Authorization: getAuthToken()
            }
          }
        );
      }
    }

  }
  static getPageData = (pageObj) => {
    return axiosInstance.get(`agency_monitor/page/content/${pageObj.id}/?kpi_page=${pageObj.kpi_page}&user_page=${pageObj.user_page}`,
      {
        headers: {
          Authorization: getAuthToken()
        }
      }
    );
  };

  static getAgencyProfileList = async (locationId) => {
    return await axiosInstance.get(`/pl/list/${locationId}/`,
        {
            headers: {
                Authorization: getAuthToken()
            }
        }
    );
  };

  static getMonitorUserSettings = async (userId) => {
    return await axiosInstance.get(`/agency_monitor/setting/override/${userId}/`,
        {
            headers: {
                Authorization: getAuthToken()
            }
        }
    );
  };

  static updateAgecnyMonitorSettings = async (userId, settingData) => {
    return await axiosInstance.put(`/agency_monitor/user/update_agency_monitor/${userId}/`, 
        settingData,
        {
            headers: {
                Authorization: getAuthToken()
            }
        }
    );
  };
  static updateRCpageUserListSettings = async (settingData) => {
    return await axiosInstance.put(`/agency_monitor/user/update_rc_user_list/`, 
        settingData,
        {
            headers: {
                Authorization: getAuthToken()
            }
        }
    );
  };


  static overrideSettings = async (userId, settingData) => {
    return await axiosInstance.put(`/agency_monitor/setting/override/${userId}/`, 
        settingData,
        {
            headers: {
                Authorization: getAuthToken()
            }
        }
    );
  };
  
  static getUserList = (locationId, monitorSettingId,allLocation=1 ) => {
    return axiosInstanceWithToken.get(
        `staff/list_with_correction_pending/${locationId}/?all_location=${allLocation}&monitor_setting_id=${monitorSettingId}`,
        
    );
  };

}



// WEBPACK FOOTER //
// ./src/services/AgencyMonitorService.js